export const getAmmounts = (year: any, trips: any) => {
  const actives = year.trips.filter((trip: any) =>
    trips.some(
      (stateTrip: any) =>
        stateTrip.id === trip &&
        stateTrip.isVisible &&
        stateTrip.isFiltered &&
        stateTrip.hidden !== true &&
        !stateTrip.isFutureTrip
    )
  ).length;
  const totals = year.trips.filter((trip: any) =>
    trips.some(
      (stateTrip: any) =>
        stateTrip.id === trip &&
        stateTrip.hidden !== true &&
        !stateTrip.isFutureTrip
    )
  ).length;
  return actives + "/" + totals;
};

export const getGlyphiconProps = (year: any) => {
  const className = "Rok_buttonIcon" + (year.isVisible ? "" : "--hidden");

  if (year.isVisible)
    return {
      icon: "visibility",
      className
    };

  return {
    icon: "visibility_off",
    className
  };
};
